import { defineStore } from 'pinia'

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: [],
  }),
  actions: {
    addToast(toast) {
      const newToast = {
        ...toast,
        show: true,
        settingsText: toast.type === 'success' ? 'View Details' : 'Settings',
        denyText: toast.type === 'warning' ? 'Cancel' : 'Dismiss',
        acceptText: toast.type === 'success' ? 'Done' : 'Accept',
      }
      this.toasts.push(newToast)

      // Auto hide after 5 seconds
      setTimeout(() => {
        this.removeToast(this.toasts.length - 1)
      }, 5000)
    },
    removeToast(index) {
      this.toasts.splice(index, 1)
    },
  },
})
